import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useOverlay from 'hooks/useOverlay';
import { useSelector } from 'react-redux';
import { AppState } from 'redux/store';

const GlobalOverlay = () => {
    const { title, content, show, onClose }: AppState['overlay'] = useSelector<AppState>((state) => state.overlay);
    const { show: modalShow }: AppState['modal'] = useSelector<AppState>((state) => state.modal);
    const [_, reset] = useOverlay();

    const backdropZIndex = modalShow ? 'tw-z-[1055]' : 'tw-z-[1051]';
    const overlayZIndex = modalShow ? 'tw-z-[1055]' : 'tw-z-[1052]';

    return (
        <div
            className={`tw-fixed tw-inset-0 tw-bg-black/50 tw-backdrop-blur-[4px] tw-transition-opacity tw-duration-200 ${backdropZIndex} ${show ? 'tw-visible tw-opacity-100' : 'tw-invisible tw-opacity-0'} `}
        >
            <div
                className={`container tw-fixed tw-bottom-0 tw-left-1/2 tw-h-[92vh] tw-w-full -tw-translate-x-1/2 tw-transform tw-rounded-t-2xl tw-bg-white tw-shadow-lg tw-transition-transform tw-duration-300 ${overlayZIndex} ${show ? 'tw-translate-y-0' : 'tw-translate-y-full'} `}
            >
                <div className="tw-flex tw-items-center tw-justify-between tw-border-0 tw-border-b tw-border-solid tw-border-accents-3 tw-px-6 tw-py-4">
                    <h3 className="tw-m-0 tw-text-lg tw-font-medium">{title}</h3>
                    <FontAwesomeIcon
                        icon={faTimes}
                        size="2x"
                        className="tw-cursor-pointer tw-transition-colors hover:tw-text-accents-7"
                        onClick={() => {
                            onClose();
                            reset();
                        }}
                    />
                </div>

                <div className="tw-h-[93%] tw-w-full tw-overflow-auto tw-p-4">{content}</div>
            </div>
        </div>
    );
};

export default GlobalOverlay;
